import { createMultiStyleConfigHelpers as o } from "@chakra-ui/react";
import { ThemeSpaceToken as e, ThemeFontSizeToken as r, ThemeFontToken as t, ThemeColorToken as n } from "../theme-tokens.js";
import { formErrorAnatomy as m } from "../../../packages/casper-ui-library/node_modules/@chakra-ui/anatomy/dist/esm/components.js";
const { definePartsStyle: i, defineMultiStyleConfig: l } = o(m.keys), f = i({
  text: {
    color: n.Error,
    fontFamily: t.Body,
    fontSize: r.Small,
    marginTop: e.XSmall
  }
}), y = l({
  baseStyle: f
});
export {
  y as formErrorConfig
};
